/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { Collapse, IconButton, MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "icons";
import { ReactComponent as PlusIcon } from "cms/assets/icons/plus.svg";
import { useState } from "react";

const MobileMenuItem = (props) => {

    const { handleClose, level, page } = props;
    const [openMenu, setOpenMenu] = useState(null);
    const [subMenuOpen, setSubMenuOpen] = useState(false);

    const handleToggleExpand = (event, pageTitle) => {
        event.stopPropagation();
        setOpenMenu(openMenu === pageTitle ? null : pageTitle);
        setSubMenuOpen((prevState) => !prevState);
    };

    return (
        <div className={`mobile-menu-nav-item level-${level}`}>
            <MenuItem onClick={handleClose}>
                <Link to={page.url} title={page.title}>
                    {page.title}
                </Link>
                {page.children.length > 0 &&
                    <IconButton onClick={(event) => handleToggleExpand(event, page.title)}>
                        {subMenuOpen &&
                            <FontAwesomeIcon
                                icon={icons.regular.faMinus}
                                size="1x"
                                fixedWidth
                            />
                        }
                        {!subMenuOpen &&
                            <PlusIcon alt='plus-icon' />
                        }
                    </IconButton>
                }
            </MenuItem>

            <Collapse in={openMenu === page.title} unmountOnExit>
                {page.children.map((childPage) => {
                    return (
                        <div key={childPage.title}>
                            <MobileMenuItem level={level + 1} page={childPage} />
                        </div>
                    );
                })}
            </Collapse>
        </div>
    );
};

export { MobileMenuItem };
